import { PlayerCourseSetup } from '@hendrx/core/courses';
import { createFileRoute, Outlet, useParams } from '@tanstack/react-router';

import { createRouteGuard } from '@/app/_lib/guards/createRouteGuard';
import { requireAuthenticated, requirePreviewModeAllowed, STUDIO_ROLES } from '@/app/_lib/guards/primitives';

export const Route = createFileRoute('/player/courses/$courseDraftIdentifier')({
  beforeLoad: createRouteGuard(requireAuthenticated(), requirePreviewModeAllowed({ allowedRoles: STUDIO_ROLES })),
  component: PlayerCourseLayout
});

function PlayerCourseLayout() {
  const params = useParams({ strict: false });

  if (!params.courseDraftIdentifier) {
    return null;
  }

  return (
    <PlayerCourseSetup
      activityId={params.activityId}
      categoryId={params.categoryId}
      courseDraftIdentifier={params.courseDraftIdentifier}
    >
      <Outlet />
    </PlayerCourseSetup>
  );
}
